<template>
  <div class="my-news-index-div1">
    <table style="width: 100%;" cellspacing="0" cellpadding="0">
      <tr height="50px">
        <td>
          <div class="my-news-index-div2">
            <span class="my-news-index-span1">新闻中心</span>
          </div>
        </td>
      </tr>
      <tr>
        <td class="my-news-index-td2">
          <router-view :key="$route.fullPath"></router-view>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import Vuex from 'vuex'

  export default {
    name: "NewsIndex",
    data() {
      return {};
    },
    components: {},
    methods: {},
    computed: {
      ...Vuex.mapGetters(["getInfo"])
    },
    created() {
      this.$store.state.activeIndex = "4";
    }
  }
</script>

<style>
  .my-news-index-div1 {
    width: 1200px;
    margin: 0 auto;
  }

  .my-news-index-span1 {
    font-size: 25px;
    font-weight: bold;
    color: white;
  }

  .my-news-index-div2 {
    width: 260px;
    background: royalblue;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
  }

  .my-news-index-td2 {
    border: 0px hidden;
    font-size: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/news/NewsIndex.vue